var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "b-navbar",
        { staticClass: "navbar is-dark" },
        [
          _c("template", { slot: "brand" }, [
            _c(
              "div",
              { staticClass: "p-t-sm p-l-sm p-r-md" },
              [
                _c("router-link", { attrs: { to: "/dashboard" } }, [
                  _c("img", {
                    staticClass: "company-logo",
                    attrs: {
                      src: require("@/assets/company-logo.png"),
                      alt: "Unit Admin"
                    }
                  })
                ])
              ],
              1
            )
          ]),
          _c(
            "template",
            { slot: "start" },
            [
              _c(
                "b-navbar-item",
                { attrs: { tag: "router-link", to: { path: "/dashboard" } } },
                [_vm._v(_vm._s(_vm.$t("menu.dashboard")))]
              )
            ],
            1
          ),
          _c("template", { slot: "end" }, [
            _c(
              "div",
              { staticClass: "navbar-item has-dropdown is-hoverable" },
              [
                _c("a", { staticClass: "navbar-link" }, [
                  _vm._v(_vm._s(_vm.$t("menu.system_menu")))
                ]),
                _c(
                  "div",
                  { staticClass: "navbar-dropdown is-boxed" },
                  [
                    _c(
                      "b-navbar-item",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: { to: "/login" },
                            nativeOn: {
                              click: function($event) {
                                return _vm.clickLogout()
                              }
                            }
                          },
                          [
                            _c("b-icon", {
                              attrs: { icon: "logout", size: "is-small" }
                            }),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("button.logout")))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ])
        ],
        2
      ),
      _c("div", { staticClass: "main-content" }, [_c("router-view")], 1),
      _c(
        "footer",
        { staticClass: "footer", staticStyle: { "margin-bottom": "-12px" } },
        [
          _c("div", { staticClass: "content has-text-centered" }, [
            _c("p", [
              _vm._v(
                "Copyright ©2020 Social Area Networks Co.,Ltd. All rights reserved."
              )
            ]),
            _c("p", [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.handleChangeLang("jp")
                    }
                  }
                },
                [_vm._v("日本語")]
              ),
              _c("span", [_vm._v("|")]),
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.handleChangeLang("en")
                    }
                  }
                },
                [_vm._v("English")]
              )
            ])
          ])
        ]
      ),
      _c("FlashMessage", { attrs: { messages: _vm.flashMessages } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }